import script from "./Services.vue?vue&type=script&setup=true&lang=js"
export * from "./Services.vue?vue&type=script&setup=true&lang=js"

import "./Services.vue?vue&type=style&index=0&id=5bfed57d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bfed57d"]])

export default __exports__